import { w as t } from "./well-known-symbol.js";
var o = t("toStringTag"),
  r = {};
r[o] = "z";
var a = "[object z]" === String(r);
export { a as t };